/* eslint-disable react-hooks/exhaustive-deps */
import CampusListView from "views/Configuracion/components/CampusListView/CampusListView";
import { configSessionStorage } from "services/storage/config";
import HeaderComponent from "./components/HeaderComponent";
import { useNavigate } from "react-router-dom";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { useEffect } from "react";
import useDashboardContext from "routes/utils/context/useDashboardContext";
import BackToSettingsView from "./components/BackToSettingsView";

const CampusListContentView = ({
    data: {
        campusList,
        spaceTypeList
    }
}) => {
    const navigate = useNavigate();
    const { userCampusId } = useDashboardContext();
    useEffect(() => {
        if (campusList.length > 0 && userCampusId)
            navigateToCampus(userCampusId);
    }, [campusList, userCampusId]);
    function navigateToCampus(campusId) {
        const campus = campusList.find(({ id }) => id === campusId);
        configSessionStorage.spaceAdmin.campus.set(campus);
        navigate(ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN_CAMPUS_SPACES);
    }
    if (userCampusId)
        return null;
    return (
        <>
            <BackToSettingsView/>
            <CampusListView
                campusList={campusList}
                onCampus={navigateToCampus}>
                <HeaderComponent spaceTypeList={spaceTypeList} />
            </CampusListView>
        </>
    );
}

export default CampusListContentView;